import React, { Component } from "react";
import DynamicListView from "../CommonComponentListView/DynamicListView";
import ModalComponent from "../../shared/ModalComponent";
import { Modal as ModalPopup } from "react-bootstrap";
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import ActionItemForm from "../../layout/Leads/ActionItemForm";
import Service from "../../../services";
import { AxiosError, AxiosResponse } from "axios";
import {
  ColumnConfig,
  FileData,
  actionItemsModel,
  documentsData,
} from "../../../models/ActionModel";
import { catchError } from "../../../utils/Utils";
import { toast } from "react-toastify";
import { ReactComponent as EditIcon } from "../../../images/edit-action-icon.svg";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import { BankUserContext } from "../../../bankUserContext";
import FilterIcon from "../../../images/filter-icon.svg";
import FilterLeads from "../../Filters/FilterLeads";
import { transformDateWithDash } from "../../../utils/dateUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { clearFilters, getFilterValue, setFilters } from "../../Filters/FiltersHelper";
import FinSpinner from "../../../commonfields/FinSpinner";
// import ReactFileViewer from "../../../commonfields/FileViewer";
import { TriggerContext } from "../../../Context/TriggerContext";
import { withContext } from "../../Authentication/RoleAuthorizationClassComponent";
import { Pages, actionAuthorization } from "../../../utils/RolesUtil";
import ReactFileViewer from "../../../commonfields/ReactFileViewer";
import { fileFormatSupported } from "../../../utils/GeneralUtils";
import { localToBinaryFileConverter } from "../../../utils/localToBinaryFileConverter";
import FileViewerModal from "../../shared/FileViewerModal";


interface options {
  id: string;
  text: string;
  value: string;
}

interface initialValues {
  action: string;
  product: string;
  contact: string;
  interaction: string;
  nextActionDate: string;
  notes: string;
}

interface actionItemsState {
  actionsData: actionItemsModel[];
  columnNames: ColumnConfig[];
  createActionItemModal: boolean;
  interactionData: options[];
  productsData: options[];
  contactsData: options[];
  initialValues: initialValues | null;
  filterModal: boolean;
  filtersData: any;
  selectedFilters: any;
  tileValues: actionItemsModel | null;
  editMode: boolean;
  pageName: string;
  loader: boolean;
  viewFile: boolean;
  documentsData: documentsData | null;
  assigneeActionToData: options[],
  defaultAssigneeActionToData: any,
}

interface initialProps {
  refreshComponent: boolean;
  contextUpdating: () => void;
  context: any;
  clientActionId?: string;
}
const notesAndDocumentsData = [
  { text: "Has Notes", value: 1 },
  { text: "Has Documents", value: 2 },
];
class ActionItemsMainCC extends Component<
  WithRouterProps<initialProps>,
  actionItemsState
> {
  service: Service;
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;

  constructor(props: any) {
    super(props);
    this.state = {
      actionsData: [],
      columnNames: [
        {
          label: "actionName",
          displayText: 6,
          columnStyling: "actionItemContainer",
          textStyling: "actionItemName",
          orderId: 1,
          mappingName: "reassign"
        },
        {
          label: "contact",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 2,
          displayLabelText: "CONTACT",
        },
        {
          label: "interaction",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 3,
          displayLabelText: "INTERACTION",
        },
        {
          label: "dateCreated",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 4,
          displayLabelText: "DATE CREATED",
        },
        {
          label: "product",
          displayText: 1,
          columnStyling: "subGroup",
          textStyling: "",
          orderId: 5,
          displayLabelText: "PRODUCT",
        },
        {
          label: "nextAction",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 7,
          displayLabelText: "NEXT ACTION",
        },
        {
          label: "notes",
          displayText: 2,
          columnStyling: "subGroup",
          orderId: 8,
          displayLabelText: "NOTES",
        },
        {
          label: "documents",
          displayText: 2,
          columnStyling: "subGroup",
          orderId: 9,
          displayLabelText: "DOCUMENTS",
          condition: this.openFileViewer,
        },

      ],
      createActionItemModal: false,
      interactionData: [],
      productsData: [],
      contactsData: [],
      initialValues: null,
      filterModal: false,
      filtersData: [],
      selectedFilters: {},
      tileValues: null,
      editMode: false,
      pageName: "actionItems",
      loader: false,
      viewFile: false,
      documentsData: null,
      assigneeActionToData: [],
      defaultAssigneeActionToData: [],
    };
    this.service = new Service();
  }
  clientId = this.props.params.clientId;
  clientActionId = localStorage.getItem('clientActionId');  //coming from action todo to open edit pop up we require this id

  removeFile = (document: any) => {
    if (document?.documentUniqueId) {
      const data = {
        "sections": "ClientActionDocument",
        "data": {
          "clientActionDocumentId": document.clientActionDocumentId
        }
      }
      this.setState({ loader: true })
      this.service.deleteFile(document?.documentUniqueId, data).then(() => {
        this.getActionParentFilterActions();
      }).catch((error: AxiosError) => {
        catchError(error, true)
      }).finally(() => {
        this.setState({ loader: false })
      })
    }

  }

  openFileViewer = async (document: any) => {
    if (document.documentUniqueId) {
      this.setState({ loader: true });
      this.service
        .getDocuments(document.documentUniqueId)
        .then((response: AxiosResponse<FileData>) => {
          if (fileFormatSupported(response?.data?.fileType)) {
            const documentObject = {
              fileName: response.data.fileName,
              fileType: response.data.fileType,
              uri: `${response.data.fileContent}`,
            };
            this.setState({ documentsData: documentObject, viewFile: true });
          }
          else {
            toast.error("FileView is not supported");
          }

        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
        .finally(() => {
          this.setState({ loader: false });
        });
    }
    else {
      const fetchData = async () => {
        try {
          this.setState({ loader: true });
          const result: any = await localToBinaryFileConverter(document);
          this.setState({ documentsData: result, viewFile: true, loader: false });
        } catch (error) {
          console.error("Error converting file:", error);
          this.setState({ loader: false });
        }
      };
      const fullType = document.path.split('.');
      const docType = fullType[fullType.length - 1];
      if (fileFormatSupported(docType)) {
        fetchData();
      }
      else {
        toast.error("FileView is not supported");
      }
    }
  }

  getActionParentFilterActions = () => {
    this.getDropDownsData();
    this.getFiltersDataProperties();
    const filters = getFilterValue(this.state.pageName);
    if (filters) {
      const newFiltersData = {
        campaigns: filters?.campaigns?.map((m: any) => m.value),
        contacts: filters?.contacts?.map((m: any) => m.value),
        interactions: filters?.interactions?.map((m: any) => m.text),
        products: filters?.products?.map((m: any) => m.value),
        notesAndDocuments: filters?.notesAndDocuments ?? null,
        date: filters?.date ? moment(filters?.date).format("MM/DD/YYYY") : null,
      };
      this.setState({ selectedFilters: filters });
      this.getActionItems(newFiltersData);

    } else {
      this.getActionItems();
    }
  }

  openActionItem = () => {
    const data = {
      screen: "ProspectDetails",
      sections: "getClientActionsByClientId",
      clientId: this.clientId,
      isJsonReturnObject: false,
    };
    this.setState({ loader: true });
    this.service
      .getActionsData(data)
      .then((response: AxiosResponse<actionItemsModel[]>) => {
        this.setState({ actionsData: response.data });
        const selectedAction = response.data?.find((item) => item.clientActionId === this.clientActionId)
        if (selectedAction) this.editActionItemModal(selectedAction)
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }

  componentDidMount(): void {
    this.getActionParentFilterActions();
    if (this.clientActionId) {
      if (this.clientActionId !== "null" && this.clientActionId.length > 10) {  // to open actionItem from action item todo
        this.openActionItem()
      }
    }
  }

  componentDidUpdate(
    prevProps: Readonly<WithRouterProps<initialProps>>,
    prevState: Readonly<actionItemsState>,
    snapshot?: any
  ): void {
    if (prevProps.refreshComponent !== this.props.refreshComponent) {
      const filters = getFilterValue(this.state.pageName);
      this.clientId = this.props.params.clientId;
      if (filters) {
        this.getDropDownsData();
      } else {
        this.getActionItems();
        this.getDropDownsData();
      }
    }
  }

  modifiedResponse = (response: options[]) => {
    return response?.map((m: options) => {
      return { ...m, value: m.id };
    });
  };
  modifyFiltersData = (filtersDataObj: any, data: any) => {
    const keys = Object.keys(filtersDataObj);
    if (keys?.length > 0) {
      keys.forEach((key: any) => {
        if (filtersDataObj[key] != null && filtersDataObj[key]?.length > 0) {
          data[key] = filtersDataObj[key];
        }
      });
    }
  };

  getDropDownsData = () => {
    const dropDownData = {
      screen: "ProspectDetails",
      sections: "ClientActionDropDownList",
      isJsonReturnObject: true,
      orgId: this.context?.bankuserDetails?.organization?.orgId,
      clientId: this.clientId,
    };
    this.setState({ loader: true });
    this.service
      .getDropDownData(dropDownData)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          const clientContacts =
            this.modifiedResponse(response.data[0].client_contacts) || [];
          const interactionData =
            this.modifiedResponse(response.data[0].client_interaction) || [];
          const productsData =
            this.modifiedResponse(response.data[0].product_name) || [];
          const assigneeActionToData =
            this.modifiedResponse(response.data[0].assigneeList) || [];
          this.setState({
            contactsData: clientContacts,
            interactionData: interactionData,
            productsData: productsData,
            assigneeActionToData: assigneeActionToData,
          });
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  getActionItems = (selectedFilterObj?: any) => {
    const data = {
      screen: "ProspectDetails",
      sections: "getClientActionsByClientId",
      clientId: this.clientId,
      isJsonReturnObject: false,
    };
    selectedFilterObj && this.modifyFiltersData(selectedFilterObj, data);
    this.setState({ loader: true });
    this.service
      .getActionsData(data)
      .then((response: AxiosResponse<actionItemsModel[]>) => {
        this.setState({ actionsData: response.data });
        return response.data
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  handleActionSave = (values: any) => {
    let formData: {
      sections: string;
      data: {
        actionName: any;
        clientId: any;
        clientProductId: any;
        interactionId: any;
        actionContact: any;
        actionStatus: any;
        nextAction: string | null;
        actionNotes: any;
        clientActionId: string | null;
        createdDate?: string;
        updatedDate?: any;
        assignedTo: any;
      };
    } = {
      sections: "createClientAction",
      data: {
        actionName: values?.action,
        clientId: this.clientId,
        clientProductId: values?.product,
        interactionId: values?.interaction,
        actionContact: values?.contact,
        actionStatus: "Active",
        nextAction: transformDateWithDash(values?.nextActionDate),
        actionNotes: values.notes !== "" ? values?.notes : null,
        clientActionId: null,
        assignedTo: values.assignActionTo,
      },

    };
    if (this.state.editMode && this.state.tileValues) {
      formData.data.clientActionId = this.state.tileValues?.clientActionId;
      formData.data.createdDate = this.state.tileValues?.createdDate;
      formData.data.updatedDate = new Date();

      if (values?.actionsItemsStatus) {
        formData.data.actionStatus = values?.actionsItemsStatus;
      } else {
        formData.data.actionStatus = this.state.tileValues?.status;
      }
    }

    this.service
      .saveActionItem(formData)
      .then((response: any) => {
        toast.success("Action Saved Successfully..!!");

        this.props?.contextUpdating();
        this.setState({ editMode: false, tileValues: null });



        let files = values?.documentTemplate;
        if (this.state.tileValues?.documents) {
          const documents = JSON.parse(this.state.tileValues?.documents)
          files = values?.documentTemplate.filter((m: any) => {
            if (documents?.find((n: any) => n?.documentUniqueId === m?.documentUniqueId)) {
              return false
            } else {
              return true
            }
          })
        }
        if (this.clientActionId) {
          localStorage.removeItem('clientActionId');
        }
        // to upload files
        if (files && files.length > 0) {
          const data = {
            section: "actionDocuments",
            clientId: this.clientId,
            clientProductId: values?.product,
            clientActionId: response.data.clientActionId,
            module: "profile",
          };
          // setLoader(true);
          this.setState({ loader: true })

          this.service
            .filesSaveAttachment(files, data)
            .then((response: any) => {
              // setLoader(false);
              this.getActionParentFilterActions();
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
              // setLoader(false);
            }).finally(() => {
              this.setState({ loader: false })
            });
        }
        else {
          this.getActionParentFilterActions();
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });

    this.createActionItem();
  };

  createActionItem = () => {
    this.getDropDownsData();
    const data = {
      action: "",
      product: "",
      contact: "",
      interaction: "",
      nextActionDate: "",
      notes: "",
      documentTemplate: "",
      assignActionTo: this.context?.bankuserDetails?.userId,
    }
    this.setState({
      createActionItemModal: !this.state.createActionItemModal,
      editMode: false,
      initialValues: data,
    });
    if (this.clientActionId) {
      localStorage.removeItem("clientActionId") // removing item on closing the pop up
    }
  };

  editActionItemModal = (tileValues: actionItemsModel) => {
    if (this.clientActionId) {
      localStorage.removeItem('clientActionId');
    }
    let documentsData = []
    if (tileValues.documents) {
      documentsData = JSON.parse(tileValues.documents)?.map((m: any) => ({ ...m, path: m.documentName, name: m.documentName }))
    }
    const initialValues = {
      action: tileValues.actionName,
      product: tileValues.clientProductsId,
      contact: tileValues.clientContactId,
      interaction: tileValues.interactionId,
      nextActionDate: tileValues.nextAction,
      notes: tileValues.notes,
      documentTemplate: documentsData,
      assignActionTo: tileValues.assignedTo,
    };
    this.setState({
      initialValues: initialValues,
      tileValues: tileValues,
      editMode: true,
      createActionItemModal: true,
    });
  };

  cancelActionItem = (tileValues: actionItemsModel) => {
    if (tileValues) {
      let formData: {
        sections: string;
        data: any;
      } = {
        sections: "createClientAction",
        data: {
          actionName: tileValues?.actionName,
          clientId: this.clientId,
          clientProductId: tileValues?.clientProductsId,
          interactionId: tileValues?.interactionId,
          actionContact: tileValues?.clientContactId,
          actionStatus: "Canceled",
          nextAction: transformDateWithDash(tileValues?.nextAction),
          actionNotes: tileValues.notes,
          clientActionId: tileValues.clientActionId,
          createdDate: tileValues.createdDate,
          assignedTo: tileValues.assignedTo,
        },
      };
      formData.data.updatedDate = new Date();

      this.service
        .saveActionItem(formData)
        .then(() => {
          toast.success("Action Canceled Successfully..!!");
          this.props.contextUpdating();
          this.setState({ tileValues: null });
          this.getActionParentFilterActions();
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        });
    }
  };

  getFiltersDataProperties = () => {
    const postData = {
      screen: "ProspectDetails",
      sections: "getActionFiltersDropdownList",
      clientId: this.props.params.clientId,
      isJsonReturnObject: true,
    };
    this.service.getLeadsData(postData).then((res: any) => {
      this.setState({ filtersData: res.data });
    });
  };
  clearAllfiltervalues = () => {
    this.setState({ selectedFilters: null });
    clearFilters();
    this.getActionItems(null);
  };
  filterModalHandler = () => {
    this.setState({ filterModal: true });
  };
  closeFilterHandler = () => {
    this.setState({ filterModal: false });
  };
  getFiltersDataHandler = (seletedFilters: any, filterFormValues: any) => {
    this.setState({ selectedFilters: filterFormValues });
    setFilters(this.state.pageName, filterFormValues);
    this.getActionItems(seletedFilters);
    this.closeFilterHandler();
  };
  getFilterText = (selectedValues: any, type: string) => {
    if (type === "product") {
      return this.state.filtersData?.[0]?.products?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "interaction") {
      return this.state.filtersData?.[0]?.interactions?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "contact") {
      return this.state.filtersData?.[0]?.contacts?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "actions") {
      return this.state.filtersData?.[0]?.campaigns?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "notesAndDocuments") {
      return notesAndDocumentsData?.find((m: any) => m.value == selectedValues)
        ?.text;
    }
    if (type === "date") {
      return moment(selectedValues).format("MM/DD/YYYY");
    }
  };
  clearProduct = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.products?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        products: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, {
      ...this.state.selectedFilters,
      products: newSelectedFilters,
    });

    const newFiltersData = {
      campaigns: this.state.selectedFilters?.campaigns?.map(
        (m: any) => m.value
      ),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.clearProduct?.map(
        (m: any) => m.text
      ),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      products: newSelectedFilters?.map((m: any) => m.value),
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getActionItems(newFiltersData);
  };
  clearInteraction = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.interactions?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        interactions: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, {
      ...this.state.selectedFilters,
      interactions: newSelectedFilters,
    });
    const newFiltersData = {
      campaigns: this.state.selectedFilters?.campaigns?.map(
        (m: any) => m.value
      ),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: newSelectedFilters?.map((m: any) => m.text),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getActionItems(newFiltersData);
  };
  clearContacts = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.contacts?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        contacts: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, {
      ...this.state.selectedFilters,
      contacts: newSelectedFilters,
    });

    const newFiltersData = {
      campaigns: this.state.selectedFilters?.campaigns?.map(
        (m: any) => m.value
      ),
      contacts: newSelectedFilters?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map(
        (m: any) => m.text
      ),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getActionItems(newFiltersData);
  };
  clearActions = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.campaigns?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        campaigns: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, {
      ...this.state.selectedFilters,
      campaigns: newSelectedFilters,
    });

    const newFiltersData = {
      campaigns: newSelectedFilters?.map((m: any) => m.value),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map(
        (m: any) => m.value
      ),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getActionItems(newFiltersData);
  };
  clearNotesAndDocuments = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.notesAndDocuments?.filter(
      (m: any) => m !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        notesAndDocuments: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, {
      ...this.state.selectedFilters,
      notesAndDocuments: newSelectedFilters,
    });

    const newFiltersData = {
      notesAndDocuments: newSelectedFilters,
      campaigns: this.state.selectedFilters?.campaigns?.map(
        (m: any) => m.value
      ),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map(
        (m: any) => m.text
      ),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getActionItems(newFiltersData);
  };
  clearDate = (selectedID: any) => {
    if (this.state.selectedFilters?.date === selectedID) {
      this.setState({
        selectedFilters: {
          ...this.state.selectedFilters,
          date: null,
        },
      });
      setFilters(this.state.pageName, {
        ...this.state.selectedFilters,
        date: null,
      });

      const newFiltersData = {
        campaigns: this.state.selectedFilters?.campaigns?.map(
          (m: any) => m.value
        ),
        contacts: this.state.selectedFilters?.contacts?.map(
          (m: any) => m.value
        ),
        interactions: this.state.selectedFilters?.interactions?.map(
          (m: any) => m.text
        ),
        products: this.state.selectedFilters?.products?.map(
          (m: any) => m.value
        ),
        notesAndDocuments: this.state.selectedFilters?.notesAndDocuments,
      };
      this.getActionItems(newFiltersData);
    }
  };

  setViewFile = () => {
    this.setState({ viewFile: !this.state.viewFile });
  };

  render() {
    const { filterModal, filtersData, selectedFilters, documentsData } =
      this.state;
    const { readOnlyMode } = this.props?.context;
    return (
      <>
        {this.state.loader && <FinSpinner />}
        <div className="action-item-wrapper">
          <div className="createAndFiltersDiv">
            {withContext(
              this.context,
              Pages.customerDetailsPage,
              actionAuthorization.createActionItem
            ) && !readOnlyMode && (
                <div
                  onClick={() => this.createActionItem()}
                  className="create-action-item"
                >
                  <span>Create</span> <EditIcon />
                </div>
              )}
            <div className="detailsPage-filters-wrap">
              <div className="selectedFilterLabels">
                {selectedFilters?.products?.map((m: any, index: number) => (
                  <span className="filteredText" key={index}>
                    {this.getFilterText(m, "product")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => this.clearProduct(m.id)}
                    />{" "}
                  </span>
                ))}
                {selectedFilters?.interactions?.map((m: any, index: number) => (
                  <span className="filteredText" key={index}>
                    {this.getFilterText(m, "interaction")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => this.clearInteraction(m.id)}
                    />{" "}
                  </span>
                ))}
                {selectedFilters?.contacts?.map((m: any, index: number) => (
                  <span className="filteredText" key={index}>
                    {this.getFilterText(m, "contact")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => this.clearContacts(m.id)}
                    />{" "}
                  </span>
                ))}
                {selectedFilters?.campaigns?.map((m: any, index: number) => (
                  <span className="filteredText" key={index}>
                    {this.getFilterText(m, "actions")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => this.clearActions(m.id)}
                    />{" "}
                  </span>
                ))}
                {selectedFilters?.notesAndDocuments?.map(
                  (m: any, index: number) => (
                    <span className="filteredText" key={index}>
                      {this.getFilterText(m, "notesAndDocuments")}{" "}
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => this.clearNotesAndDocuments(m)}
                      />{" "}
                    </span>
                  )
                )}
                {selectedFilters?.date ? (
                  <span className="filteredText">
                    {this.getFilterText(selectedFilters?.date, "date")}{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      onClick={() => this.clearDate(selectedFilters?.date)}
                    />{" "}
                  </span>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="filtersDiv-detailsPage"> */}
              <Button
                style={{ marginLeft: "0px" }}
                className="filtersBtn-detailsPage-actionItems"
                onClick={this.filterModalHandler}
              >
                <img
                  src={FilterIcon}
                  alt="FilterIcon"
                  className="filter-icon"
                />
                <span className="filter-text">Filters</span>
              </Button>
              {/* </div> */}
            </div>
          </div>
          <div className="actionItemContainer">
            <DynamicListView
              tilesData={this.state.actionsData}
              columnNames={this.state.columnNames}
              modalCondtion={this.editActionItemModal}
              cancelActionItem={this.cancelActionItem}
              className={"actionItemTile"}
              showMenuItems={withContext(
                this.context,
                Pages.customerDetailsPage,
                actionAuthorization.editActionItem
              ) && !readOnlyMode}
            />
          </div>

          <ModalComponent
            showModal={this.state.createActionItemModal}
            modalToggle={this.createActionItem}
            className="actionItemModal"
            HeaderName={
              this.state.editMode ? "Edit Action Item" : "Create Action Item"
            }
          >
            <Container fluid>
              <ActionItemForm
                handleActionItemSave={this.handleActionSave}
                interactionData={this.state.interactionData}
                contactsData={this.state.contactsData}
                productsData={this.state.productsData}
                initialData={this.state.initialValues}
                edit={this.state.editMode}
                createdDate={this.state.tileValues?.dateCreated}
                openFileViwer={this.openFileViewer}
                removeFile={this.removeFile}
                assignActionToData={this.state.assigneeActionToData}
                loader={this.state.loader}
              // defaultAssigneeActionToData={this.state.defaultAssigneeActionToData}
              />
            </Container>
          </ModalComponent>
          <ModalPopup
            show={filterModal}
            onHide={this.filterModalHandler}
            className="filter-modal actionItem"
            autoFocus={false}
          >
            <ModalPopup.Header closeButton onClick={this.closeFilterHandler}>
              Filters
            </ModalPopup.Header>
            <ModalPopup.Body>
              <FilterLeads
                getFiltersDataHandler={this.getFiltersDataHandler}
                filtersData={filtersData}
                filterType="detailsPageFilters"
                notesAndDocumentsData={notesAndDocumentsData}
                selectedFilters={selectedFilters}
                clearAllfiltervalues={this.clearAllfiltervalues}
              />
            </ModalPopup.Body>
          </ModalPopup>
          <div className="fileViewerModalContainer">
            <FileViewerModal
              viewFile={this.state.viewFile}
              setViewFile={this.setViewFile}
              documentsData={documentsData}
            />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter<WithRouterProps<initialProps>>(ActionItemsMainCC);
